import { useEffect, useState } from 'react';
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';

// GA pageview tracking is non-critical for first paint. Mount after idle so the
// hook's listeners and gtag calls don't run during hydration.
function GoogleAnalyticsInner() {
  useGoogleAnalytics();
  return null;
}

export const GoogleAnalyticsTracker = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const start = () => { if (!cancelled) setReady(true); };

    if ('requestIdleCallback' in window) {
      const id = (window as any).requestIdleCallback(start, { timeout: 4000 });
      return () => { cancelled = true; (window as any).cancelIdleCallback?.(id); };
    }
    const t = setTimeout(start, 2000);
    return () => { cancelled = true; clearTimeout(t); };
  }, []);

  if (!ready) return null;
  return <GoogleAnalyticsInner />;
};
